import { useMapped } from "@omni/utils/context/mapped.context";
import { ReactNode } from "react";

import { UspContextProvider } from "@/components/Blocks/usps/components/context/usp.context";
import { useUspsContext } from "@/components/Blocks/usps/context/usps.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Base = ({ className, children }: Props) => {
    const { usps } = useUspsContext();
    const { index } = useMapped();

    const usp = usps[index];

    return (
        <UspContextProvider usp={usp}>
            <li className={className}>{children}</li>
        </UspContextProvider>
    );
};
